import { defineMessages } from 'react-intl';

export default defineMessages({
  apexuser: {
    id: 'sentinel.components.login.apexuser',
    defaultMessage: 'Apex User',
  },
  password: {
    id: 'sentinel.components.login.password',
    defaultMessage: 'Password*',
  },
  submit: {
    id: 'sentinel.components.login.submit',
    defaultMessage: 'Sign In',
  },
  title: {
    id: 'sentinel.components.login.title',
    defaultMessage: 'Sign In to Apex Online',
  },
  username: {
    id: 'sentinel.components.login.username',
    defaultMessage: 'Username*',
  },
  loginTypeUsername: {
    id: 'sentinel.components.login.loginTypeUsername',
    defaultMessage: 'Username / E-mail Address*',
  },
  checkUsername: {
    id: 'sentinel.components.login.checkUserName',
    defaultMessage: 'Next',
  },
});



// WEBPACK FOOTER //
// ./src/containers/Login/messages.js